export const options = [
  {
    name: "Bitcoin",
    minAmount: "$1000",
    duration: "48hrs",
  },
  {
    name: "Ethereum",
    minAmount: "$1000",
    duration: "48hrs",
  },
  {
    name: "Litecoin",
    minAmount: "$1000",
    duration: "48hrs",
  },
  {
    name: "Shiba",
    minAmount: "$1000",
    duration: "48hrs",
  },
  {
    name: "Bank Transfer",
    minAmount: "$1000",
    duration: "24-48hrs",
  },
];
